import React from 'react'

/**
 * Icon3D — icono moderno con "tile" 3D a color (gradiente + brillo + sombra profunda).
 *
 * Props:
 *  - icon: componente de lucide-react (ej. MapPin)
 *  - color: nombre de la paleta (amber, orange, red, rose, pink, purple, violet,
 *           indigo, blue, sky, cyan, teal, emerald, green, lime, yellow, slate, gray)
 *  - size: 'sm' | 'md' | 'lg' | 'xl'
 *  - className: clases extra para el contenedor
 *  - title: tooltip nativo
 *  - strokeWidth: grosor del trazo (default 2.25)
 */
const SIZES = {
  sm: 'icon3d-sm',
  md: 'icon3d-md',
  lg: 'icon3d-lg',
  xl: 'icon3d-xl',
}

export default function Icon3D({
  icon: Icon,
  color = 'amber',
  size = 'md',
  className = '',
  title,
  strokeWidth = 2.25,
}) {
  return (
    <span
      className={`icon3d icon3d-${color} ${SIZES[size] || SIZES.md} ${className}`}
      title={title}
    >
      <Icon strokeWidth={strokeWidth} />
    </span>
  )
}

// Paleta reutilizable para mapas de color por sección
export const ICON_COLORS = {
  dashboard: 'amber',
  trackers:  'blue',
  search:    'violet',
  toka:      'red',
  oui:       'yellow',
  telcel:    'sky',
  allce:     'purple',
  att:       'cyan',
  otras:     'slate',
  upload:    'emerald',
  settings:  'gray',
}
